<template>
    <v-container>
       <v-card class="mx-auto" elevation="12">            
            <v-data-table
                :headers="headers"
                :items="machines"
                hide-default-header
                class="elevation-1"                    
                :expanded.sync="expanded"
                single-expand
                item-key="UUID"
                show-expand
                :loading="isLoading"> 
                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                         <span v-for="itm in item.forwarded_ip" >
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">                       
                                    <v-chip  v-on="on" class="ma-2" color="orange darken-4" outlined v-clipboard="itm.ip">  
                                        <v-icon left>mdi-lan</v-icon>{{ itm.name }} {{ itm.ip }}                              
                                    </v-chip>
                                </template>
                                <span>Click to copy ip address</span>
                                </v-tooltip>
                        </span>
                    </td>
                </template>
                <template v-slot:item.display="{ item }" >
                    <div v-if="item.connected">
                        <v-icon  large color='green darken-4'>mdi-lan-connect</v-icon>
                        {{ (item.userConnected != user.user_name) ? item.userConnected  : '' }}
                       
                    </div>
                </template>
                <template v-slot:item.action="{ item }" >
                    <div v-if="item.offline">
                        <v-btn block color="orange darken-4" class="ma-2 white--text" disabled>
                            <v-icon left dark>mdi-cloud-off-outline</v-icon> offline
                        </v-btn>
                    </div>
                    <div v-else>                 
                        <v-btn v-if="item.connected" block color="orange darken-4" class="ma-2 white--text" @click="disconnect(item.UUID)" :disabled="!item.enabled || isLoading">
                            <v-icon left dark>mdi-lan-disconnect</v-icon> disconnect                                 
                        </v-btn>     
                        <v-btn v-else block  color="orange darken-4" class="ma-2 white--text" @click="connect(item.UUID)" :disabled="!item.enabled || isLoading">
                            <v-icon left dark>mdi-lan-connect</v-icon> connect                                
                        </v-btn> 
                </div>
                </template>
            </v-data-table>
        </v-card>           
    </v-container>
</template>

<script>
import { mapState } from 'vuex'
  export default {
    name: 'vpnList',
    props:{},
    data: function() {
        return {
            expanded: [],
            headers: [ 
                         
                { text: "plant", value: "plant" },
                { text: "name", value: "name" },
                { text: "description", value: "description" },
                { text: 'Display', value: 'display', sortable: false },
                { text: 'Actions', value: 'action', sortable: false },
            ], 
        }
    },
    computed: {
        ...mapState([
            'user',
            'isLoading',
            'machines'
        ])
    },
    created () {
        this.$store.dispatch('loadVPNMachines');
        this.$store.dispatch('vpn_status');
     },
    
    methods: {
        connect(UUID) {
            this.$store.dispatch('vpn_start',UUID); 
        },
        disconnect(UUID){ 
            this.$store.dispatch('vpn_stop',UUID); 
        } 
    }
}
</script>
 